import { Skeleton } from '@/components/ui/skeleton';

const InfoLoader = () => (
  <div className="flex gap-4">
    <Skeleton className="w-10 h-10 rounded-md" />
    <div className="grow flex flex-col gap-2.5 max-w-[270px]">
      <Skeleton className="w-full-[250px] min-h-4 rounded-lg" />
      <Skeleton className="w-[150px] min-h-3 rounded-lg" />
      <Skeleton className="w-[150px] min-h-3 rounded-lg" />
    </div>
    <Skeleton className="min-w-9 h-9 rounded-md" />
  </div>
);

export default InfoLoader;
